import { Routes } from '@angular/router';
import { WalletConnectComponent } from './modules/components/wallet-connect/wallet-connect.component';
import { ProposeTransactionComponent } from './modules/components/propose-transaction/propose-transaction.component';
import { ViewAllTransactionComponent } from './modules/components/view-all-transaction/view-all-transaction.component';
import { noAuthGuard } from './modules/guards/no-auth.guard';
import { authGuard } from './modules/guards/auth.guard';

export const routes: Routes = [
    { path: '', component: WalletConnectComponent, canActivate: [noAuthGuard] },
    { path: 'propose-transaction', component: ProposeTransactionComponent, canActivate: [authGuard] },
    { path: 'view-all-transaction', component: ViewAllTransactionComponent, canActivate: [authGuard] }
];
